<template>
  <div class="page-film" v-if="showPage">
    <div class="film-public-banner" v-if="film.coverPicture" :style="{'background-image': 'url(' + film.coverPicture + ')'}"></div>
    <div class="film-public-banner" v-else style="{'background-image': 'url('http://ocs.21teacher.com/dir-image/2020/8/28/5c2a366d475a4ff89d982e6b4cb8c6bf.jpg')'}"></div>

    <div class="common-wrap">
      <div class="paeparation">
        <div class="search">
          <el-input class="ipt" clearable size="large" v-model="params.sectionName" placeholder="请输入片名或关键字"></el-input>
          <div class="btn" v-on:click="search(1)">
            <i class="el-icon-search" ></i> 搜索
          </div>
        </div>
      </div>
      <ul class="navi clearfix">
        <li :class="params.orderType == 'all' ? 'active': ''" v-on:click="searchType('all')">全部</li>
        <li :class="params.orderType == 'previewTimes' ? 'active': ''" v-on:click="searchType('previewTimes')">热门</li>
        <li :class="params.orderType == 'start' ? 'active': ''" v-on:click="searchType('start')">星级</li>
        <!-- <li :class="params.orderType == 'recomend' ? 'active': ''" v-on:click="searchType('recomend')">推荐</li> -->
      </ul>
      <div class="paeparation-result clearfix" v-if="total>0" v-loading="listLoading">


        <div class="work-card-one film-item" v-for="(item, index) in tableData" :key="index" >
          <router-link target="_blank" :to="{path:'/filmdetail', query: {id:item.id}}"  class="img-f">
            <img :src="item.sectionThumbnail" alt="">
          </router-link>
          <router-link :to="{path:'/filmdetail', query: {id:item.id}}"  class="card-infoes">
            <div class="card-tit over-ellipsis">{{item.sectionName}}</div>
            <div class="card-czs film-rate clearfix">
              <i class="icon watch"></i>
              <span class="much">{{item.previewTimes}}</span>
              <i class="icon pinglun"></i>
              <span class="much">{{item.commentCount}}</span>
              <el-rate
                :value="item.sectionScore / 2"
                disabled
                :colors="{2: '#ee4b58', 4: '#ee4b58', 5: '#ee4b58'}"
                show-text
                :texts="setTexts(item.sectionScore)"
                text-color="#5a5a5a"
              >
              </el-rate>
            </div>
          </router-link>
          <router-link :to="{path:'/filmdetail', query: {id:item.id}}" target="_blank" class="film-mask">
            <div class="ji-desc">{{item.sectionIntroduction}}</div>
          </router-link>
        </div>




      </div>

      <div class="pagintion-f" v-if="total>0">
        <el-pagination
                background
                @current-change="search"
                layout="prev, pager, next"
                :current-page="params.pageIndex"
                :page-size="params.pageSize"
                :total="total"
                :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import filmMixins from '../mixins.js'
import filmApi from "@/api/film";
import updateTdk from "@/utils/tdk";
import questionApi from "../../../api/question";

export default {
  mixins: [filmMixins],
  data () {
    return {
      headTitle: "人人动画网【官网】",
      headKeywords: "人人动画网【官网】",
      headDesc: "人人动画网【官网】",
      isMounted: false, //for control not ssr render

      listLoading:false,
      film:{},
      tableData:[],
      total:0,
      params:{
        sectionName:'',
        pageIndex:1,
        pageSize:8,
        //orderType:'all',
        orderType:'allall',
        courseId:0,
      },
      searchIpt: '',
      rateVal: 9.2,
      showPage:false,
    }
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com/gquestions">`
    };
  },
  serverPrefetch() {
    return this.initData();
  },
  beforeRouteUpdate(to, from, next) {
    this.initData()
    next();
  },
  mounted () {
    this.isMounted = true;
    setTimeout(()=>{
      if(this.global.isLogin) {
        this.isLogin = true
      }
    },200)
    this.initData()
  },
  methods: {
    setSeo() {
      this.headTitle = "放映厅剧集列表——人人动画网【官网】";
      this.headKeywords = "放映厅剧集列表——人人动画网【官网】";
      this.headDesc = "放映厅剧集列表——人人动画网【官网】";
    },
    initData(){
      let num = this.$route.query.num

      if(num == undefined){
        num = 1
      }

      filmApi.selectByNum(num).then(re =>{

        this.film = re.response

        this.search(1)
      })

    },
    searchType(type){
      this.params.orderType= type
      this.search(1)
    },
    search(page){
      this.listLoading = true
      this.params.courseId = this.film.id
      this.params.pageIndex = page
      filmApi.getSectionPage(this.params).then(re => {


        this.tableData = re.list

        if(this.tableData.length >0){
          console.log(this.tableData[0].id)

          //http://www.renrendonghua.com/filmdetail?id=2801

          try {
            this.tableData.forEach( item =>{
              if (item.videoId) {
                //console.log("sectionName:",item.sectionName,"videoId:",item.videoId)
                window.location.href = '/filmdetail?id='+item.id
                throw Error();
              }
            })
          } catch (e) {
          }

          /*this.tableData.forEach( item =>{
            console.log("sectionName:",item.sectionName,"videoId:",item.videoId)
            if(item.videoId){
              //window.location.href = '/filmdetail?id='+item.id
              return false
            }

          })*/

        }else {
          this.$message.error('当前放映厅没有剧集')
        }

        /*
        目前直接跳转第一节 ，课节列表隐藏
        this.tableData.forEach(item =>{
          if(item.sectionThumbnail.indexOf("backImg1") >-1 ){
            let jsonBackImg =  JSON.parse(item.sectionThumbnail)

            item.sectionThumbnail = jsonBackImg.backImg2



          }

        })*/

        this.total = re.total
        this.params.pageIndex = re.pageNum
        this.listLoading = false
      })

      //this.hot()
      this.setSeo()
      updateTdk.call(this)
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/stylePublic.less";
.page-film{
  padding-top: @NAVHEIGHT;
  .paeparation{
    margin: 20px 10px 10px;
  }
  .navi{
    padding: 0 10px;
    margin-bottom: 10px;
    li{
      float: left;
      margin-right: 20px;
      height: 30px;
      line-height: 28px;
      color: #aaa;
      cursor: pointer;
      &.active{
        color: #575757;
        border-bottom: 2px solid #575757;
      }
    }
  }
}
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
</style>
